<template>
  <section v-if="!isMobile">
    <p>GIF yourself a break with bubly</p>
    <p class="mobile-only">
      <a href="https://giphy.com/bublywater" target="_blank">
        GIF yourself a break with bubly<br>
        <span>see more at GIPHY</span></a>
    </p>
  </section>
</template>

<script>
  export default {
    name: 'allFlavors',
    data() {
      return {
        isMobile: false
      }
    },
  };
</script>

<style lang='scss' scoped>
  @import './../variables';
  
  section {
    background-color: $bubly-blue;
  }

  p {
    font-size: 29px;
    margin:0;
    padding: 0;
    position: relative;
    display: none;
    font-weight: bold;
    span {
      display: inline-block;
      font-size: 15px;
      margin-top: 10px;
      padding: 0 40px;
      background: url("/static/images/double-arrow.png") 92% 44% no-repeat;
      background-size: 6%;
    }

    &.mobile-only {
      display: inline-block;
      font-size: 24px;
      a {
        padding: 29px 15px;
        display: block;
      }
    }

    @include breakpoint('tablet') {
      font-size: 40px;
      display: inline-block;
      margin: 40px 15px;
      span {
        font-size: 19px;
      }
      &.mobile-only {
        display: none;
      }
    }
  }

  
</style>



// WEBPACK FOOTER //
// src/components/AllFlavors.vue